import { Observer } from 'mobx-react-lite'
import { Card } from 'ui-components-web'
import { ThemeProvider } from '@material-ui/core/styles'

import overrideTheme from 'theming/overrides/cards/visit'
import useStyles from './styles'
import VisitCardsExpansion from 'singletons/VisitCardsExpansion'
import CollapsedBlock from './common/CollapsedBlock'
import classNames from '@ui-components-3/ui/lib/utils/classNames'
import FileMedicalIcon from '@ui-components-3/icons/lib/duotone/FileMedical'
import ViewDetailsButton from '../common/ViewDetailsButton'

const getDisplayVisitType = (visitType: string, scheduledType: string) => {
  const isNow = scheduledType === 'now'

  switch (visitType) {
    case 'therapy':
      return isNow ? 'TalkNow' : 'Therapy'
    case 'hc':
      return 'Health Coaching'
    case 'success_coaching':
      return `Success Coaching${isNow ? ' - On Demand' : ''}`
    default:
      return visitType
  }
}

type VisitCardOldProps = {
  visit: any
  parentVisit?: any
  memberMode?: boolean
  editable?: boolean
  providerMode?: boolean
}

const VisitCardOld = ({ visit, parentVisit, editable, memberMode, providerMode }: VisitCardOldProps) => {
  const classes = useStyles()

  if (!visit) {
    return null
  }

  return (
    <ThemeProvider theme={overrideTheme}>
      <Card className={classes.root}>
        <div className={classes.headerContainer}>
          <h5 className="typography-body-xxl text-primary-800 tracking-tighter">
            <Observer>{() => (memberMode ? visit.memberFullName : visit.providerName)}</Observer>
          </h5>
          <ViewDetailsButton visit={visit} buttonSize="btn-small" buttonType="btn-primary-outlined" />
        </div>

        <div className={classes.row}>
          <div className={classes.bottomInfoContainer}>
            <FileMedicalIcon className="mt-0.5 text-neutral-400 w-4 h-4 mr-2" aria-hidden="true" />
            <div>
              <p className="typography-body-l font-medium text-neutral-800 tracking-tight uppercase">
                <Observer>{() => <>{getDisplayVisitType(visit.visitType, visit.scheduledType)}</>}</Observer>
              </p>
            </div>
          </div>
        </div>

        <Observer>
          {() => {
            const expanded = VisitCardsExpansion.expanded(visit.pendingVisitId)
            return expanded ? (
              <CollapsedBlock
                visit={visit}
                parentVisit={parentVisit}
                editable={editable}
                memberMode={memberMode}
                providerMode={providerMode}
              />
            ) : null
          }}
        </Observer>
      </Card>
    </ThemeProvider>
  )
}

export default VisitCardOld
